import React from "react";
import { homeImages } from "../constants/homeImages";
import "./Expertise.css";
import "./homeGraphic.css";

const Expertise = () => {
  const items = [
    {
      title: "Corporate Event",
      text: "We curate high-impact corporate events that reflect elegance, professionalism, and brand excellence. From exclusive conferences to sophisticated product launches, every detail is designed to impress and perform flawlessly.",
    },
    {
      title: "Wedding Planning",
      text: "We craft luxury weddings that are timeless, elegant, and deeply personal. With refined aesthetics and meticulous planning, we transform your vision into an unforgettable celebration of love and style.",
    },
    {
      title: "Social Event",
      text: "We design stylish social gatherings that exude sophistication and charm. From intimate celebrations to grand soirées, we deliver seamless experiences that leave lasting impressions.",
    },
    {
      title: "Public Event",
      text: "We specialize in premium large-scale public events with a focus on precision, safety, and visual excellence. Our expert planning and technical execution ensure impactful experiences on a grand stage.",
    },
  ];

  return (
    <section id="expertise" className="expertise">
      <div className="expertise-container">
        <div className="section-header expertise-section-header">
          <h2 className="section-title">Our Expertise</h2>
          <div className="title-underline"></div>
          <p className="expertise-tagline">
            &ldquo;Turning Creative Ideas Into Perfectly Executed Events&rdquo;
          </p>
        </div>
        <div className="expertise-grid">
          {items.map((item, index) => (
            <article
              key={item.title}
              className={`expertise-card${
                index % 2 === 1 ? " expertise-card--reverse" : ""
              }`}
            >
              <div className="expertise-card__graphic">
                <div className="home-graphic-wrap home-graphic-wrap--expertise-row">
                  <img
                    src={homeImages.expertise[item.title]}
                    alt={item.title}
                    className="home-graphic-img"
                    decoding="async"
                    loading={index > 0 ? "lazy" : "eager"}
                  />
                </div>
              </div>
              <div className="expertise-card__body">
                <h3 className="expertise-card__title">{item.title}</h3>
                <p className="expertise-card__text">{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
